import ConfirmSwitch from "../../microComponents/modals/ConfirmSwitch";
import DrawerTable from "./DrawerTable";


const ProductionLineColumn = () => {


    const columns = [

        {
            title: 'ردیف',className: "hidden lg:table-cell", dataIndex: 'row', key: 'row', render: (text, row, index) => {
                return index + 1;
            },
        },  {
            title: ' واحد',
            dataIndex: 'branch',
            key: 'branch',
        },
        {
            title: ' خط تولید',
            dataIndex: 'productLine',
            key: 'productLine',
        },




        {
            title: ' محصول',className: "hidden 2xs:table-cell",
            dataIndex: 'product',
            key: 'product',
        },
        {
            title: 'تعداد چاپ شده',className: "hidden sm:table-cell",
            dataIndex: 'printedCounter',
            key: 'printedCounter',
        },
        {
            title: 'تحویل به انبار',className: "hidden sm:table-cell",
            dataIndex: 'registredCounter',
            key: 'registredCounter',
            render: (item, row) => {
                return <div>{row.totalRgisterdCounter > 0 && (`${row.registredCounter} (${row.totalRgisterdCounter}) `)}</div>

            }
        },

        {
            title: 'ابطال',className: "hidden md:table-cell",
            dataIndex: 'cancleCounter',
            key: 'cancleCounter',
        },
        {
            title: 'در حال بررسی',className: "hidden 2md:table-cell",
            dataIndex: 'quarantineCounter',
            key: 'quarantineCounter',
            render: (item, row) => {
                return <div>{row.totalQuarantineCounter > 0 && (`${row.quarantineCounter} (${row.totalQuarantineCounter}) `)}</div>

            }
        },

        {
            title: 'امحا',className: "hidden 2md:table-cell",
            dataIndex: 'destroyedCounter',
            key: 'destroyedCounter',
            render: (item, row) => {
                // todo test this line
                return <div>{row.totalDestroyedCounter > 0 && (`${row.destroyedCounter} (${row.totalDestroyedCounter}) `)}</div>
            }
        },
        {
            title: 'بازسازی شده',className: "hidden 2md:table-cell",
            dataIndex: 'totalReconstructCounter',
            key: 'totalReconstructCounter',
            render: (item) => {
                return <span>{!!item && item}</span>
            }

        },
        {
            title: ' تعداد در پالت',className: "hidden lg:table-cell",
            dataIndex: 'numberPerPallet',
            key: 'numberPerPallet',

        },


        {
            title: ' سرپرست تولید',className: "hidden lg:table-cell",
            dataIndex: 'createBy',
            key: 'createBy',
        },



        {
            title: 'تاریخ ثبت',className: "hidden lg:table-cell",
            dataIndex: 'startTime',
            key: 'startTime',
        },


        {fixed: 'right',  className: 'left-104 cell-fix-left',
            title: 'ثبت نشده',
            dataIndex: 'notRegister',
            key: 'notRegister',
            render: (item, row) => {
                let cancleCounter = Number(row.cancleCounter)
                let registredCounter = Number(row.registredCounter)
                let printedCounter = Number(row.printedCounter)
                return <div>{cancleCounter + registredCounter < printedCounter &&
                    //   open drawer by filter id = row.id and palletStatus = 1
                    <DrawerTable
                        filter={{ProductSeri: row.id, palletStatus: 1, page: 1, page_size: 1000}}
                        buttonNumber={printedCounter - (cancleCounter + row.registredCounter)}
                    />}</div>
            }
        },


        {
            title: 'وضعیت',
            dataIndex: 'seriesStatus',
            key: 'seriesStatus',
            fixed: 'right',  className: ' cell-fix-left',


            render: (item, row) => {

                return <ConfirmSwitch hidden={row.seriesStatus === null} address='ProductSeries/Status' rowData={row}
                                      defStatus={row.seriesStatus}/>
            }
        },


    ];
    return [columns];
};

export default ProductionLineColumn;